import type { PublicSlotKey } from '#packages/apilib';
import type { EditorPaasApi } from './editorPaasApi';

export const EditorPaasApiKey: PublicSlotKey<EditorPaasApi> = {
  name: 'EditorPaasApi',
  public: true,
};
